import React, { useState, useEffect } from 'react';
import axios from 'axios';
import ButtonItem from '../components/ButtonItem';
import DaumPostcode from 'react-daum-postcode';
import { useNavigate, useParams, useLocation } from 'react-router-dom';

function ClientWritePage() {
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams();
  const params = new URLSearchParams(location.search);
  const page = params.get('page');
  const search = params.get('search');
  const searchParam = search ? `&search=${encodeURIComponent(search)}` : '';
  const [clients, setClients] = useState([]);
  const [name, setName] = useState('');
  const [nickName, setNickName] = useState('');
  const [phone1, setPhone1] = useState('');
  const [phone2, setPhone2] = useState('');
  const [phone3, setPhone3] = useState('');
  const [emailId, setEmailId] = useState('');
  const [emailDomain, setEmailDomain] = useState('gmail.com');
  const [customDomain, setCustomDomain] = useState('');
  const [zonecode, setZonecode] = useState(''); // 우편번호
  const [address, setAddress] = useState(''); // 기본주소
  const [detailAddress, setDetailAddress] = useState(''); // 상세주소
  const [type, setType] = useState('');
  const [rrn1, setRrn1] = useState('');
  const [rrn2, setRrn2] = useState('');
  const [rrnA, setRrnA] = useState('');
  const [rrnB, setRrnB] = useState('');
  const [rrnC, setRrnC] = useState('');
  const [bank, setBank] = useState('');
  const [account, setAccount] = useState('');
  const [holder, setHolder] = useState('');
  const [showPostcode, setShowPostcode] = useState(false);
  const [password, setPassword] = useState('');


  useEffect(() => {
    setName(clients.name || '');
    setNickName(clients.nickName || '');
    setPhone1(clients.phone1 || '');
    setPhone2(clients.phone2 || '');
    setPhone3(clients.phone3 || '');
    setEmailId(clients.emailId || '');
    setEmailDomain(clients.emailDomain || 'gmail.com');
    setCustomDomain(clients.customDomain || '');
    setZonecode(clients.zonecode || '');
    setAddress(clients.address || '');
    setDetailAddress(clients.detailAddress || '');
    setType(clients.type || '');
    setRrn1(clients.rrn1 || '');
    setRrn2(clients.rrn2 || '');
    setRrnA(clients.rrnA || '');
    setRrnB(clients.rrnB || '');
    setRrnC(clients.rrnC || '');
    setBank(clients.bank || '');
    setAccount(clients.account || '');
    setHolder(clients.holder || '');
  }, [clients]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/client/${id}`
        );
        setClients(response.data);
      } catch (error) {
        console.error('서버 접속 에러:', error);
      }
    };
    fetchData();
  }, [id]);

  // 주소 검색 API
  const handleAddressSearch = () => {
    setShowPostcode(true);
  };

  const handlePostcodeComplete = (data) => {
    setZonecode(data.zonecode);
    setAddress(data.address);
    setShowPostcode(false); // 주소 검색 후 팝업 닫기
  };

  // 각 인풋 값 저장
  const nameValueChange = (event) => setName(event.target.value);
  const nickNameValueChange = (event) => setNickName(event.target.value);
  const phone1Change = (event) => {
    const inputValue = event.target.value;
    if (/[^0-9]/.test(inputValue)) {
      alert('숫자만 입력할 수 있습니다.');
    }
    setPhone1(inputValue.replace(/[^0-9]/g, ''));
  };
  const phone2Change = (event) => {
    const inputValue = event.target.value;
    if (/[^0-9]/.test(inputValue)) {
      alert('숫자만 입력할 수 있습니다.');
    }
    setPhone2(inputValue.replace(/[^0-9]/g, ''));
  };
  const phone3Change = (event) => {
    const inputValue = event.target.value;
    if (/[^0-9]/.test(inputValue)) {
      alert('숫자만 입력할 수 있습니다.');
    }
    setPhone3(inputValue.replace(/[^0-9]/g, ''));
  };
  const emailIdChange = (event) => setEmailId(event.target.value);
  const emailDomainChange = (event) => {
    const value = event.target.value;
    setEmailDomain(value);
    if (value !== 'custom') {
      setCustomDomain('');
    }
  };
  const customDomainChange = (event) => setCustomDomain(event.target.value);
  const addressValueChange = (event) => setDetailAddress(event.target.value);
  const typeValueChange = (event) => setType(event.target.value);
  const rrn1Change = (event) => {
    const inputValue = event.target.value;
    if (/[^0-9]/.test(inputValue)) {
      alert('숫자만 입력할 수 있습니다.');
    }
    setRrn1(inputValue.replace(/[^0-9]/g, ''));
  };
  const rrn2Change = (event) => {
    const inputValue = event.target.value;
    if (/[^0-9]/.test(inputValue)) {
      alert('숫자만 입력할 수 있습니다.');
    }
    setRrn2(inputValue.replace(/[^0-9]/g, ''));
  };
  const rrnAChange = (event) => {
    const inputValue = event.target.value;
    if (/[^0-9]/.test(inputValue)) {
      alert('숫자만 입력할 수 있습니다.');
    }
    setRrnA(inputValue.replace(/[^0-9]/g, ''));
  };
  const rrnBChange = (event) => {
    const inputValue = event.target.value;
    if (/[^0-9]/.test(inputValue)) {
      alert('숫자만 입력할 수 있습니다.');
    }
    setRrnB(inputValue.replace(/[^0-9]/g, ''));
  };
  const rrnCChange = (event) => {
    const inputValue = event.target.value;
    if (/[^0-9]/.test(inputValue)) {
      alert('숫자만 입력할 수 있습니다.');
    }
    setRrnC(inputValue.replace(/[^0-9]/g, ''));
  };
  const setAccountChange = (event) => {
    const inputValue = event.target.value;
    if (/[^0-9]/.test(inputValue)) {
      alert('숫자만 입력할 수 있습니다.');
    }
    setAccount(inputValue.replace(/[^0-9]/g, ''));
  };
  const passwordValueChange = (event) => setPassword(event.target.value);

  const add = async () => {
    // 입력값 검사
    if (!name) return alert('권리사명을 입력해 주세요.');
    if (!nickName) return alert('닉네임을 입력해 주세요.');
    if (!phone1 || !phone2 || !phone3)
      return alert('전화번호를 정확히 입력해 주세요.');
    if (!emailId) return alert('이메일 아이디를 입력해 주세요.');
    if (emailDomain === 'custom' && !customDomain)
      return alert('이메일 도메인을 입력해 주세요.');
    if (!address) return alert('주소를 입력해 주세요.');
    if (!type) return alert('유형을 선택해 주세요.');
    if (
      (type === '개인' && (!rrn1 || !rrn2)) ||
      (type === '사업자' && (!rrnA || !rrnB || !rrnC))
    ) {
      return alert('주민등록번호 또는 사업자등록번호를 입력해 주세요.');
    }
    if (!bank) return alert('은행명을 입력해 주세요.');
    if (!account) return alert('계좌번호를 입력해 주세요.');
    if (!holder) return alert('예금주를 입력해 주세요.');

    const emailUrl = emailDomain === 'custom' ? customDomain : emailDomain;

    const formData = new FormData();
    formData.append('name', name);
    formData.append('nickName', nickName);
    formData.append('phone1', phone1);
    formData.append('phone2', phone2);
    formData.append('phone3', phone3);
    formData.append('emailId', emailId);
    formData.append('emailDomain', emailUrl);
    formData.append('address', address);
    formData.append('type', type);
    formData.append('bank', bank);
    formData.append('account', account);
    formData.append('holder', holder);
    formData.append('password', password);

    // 선택값이 있는 경우에만 추가
    if (zonecode) formData.append('zonecode', zonecode);
    if (detailAddress) formData.append('detailAddress', detailAddress);
    if (rrn1) formData.append('rrn1', rrn1);
    if (rrn2) formData.append('rrn2', rrn2);
    if (rrnA) formData.append('rrnA', rrnA);
    if (rrnB) formData.append('rrnB', rrnB);
    if (rrnC) formData.append('rrnC', rrnC);

    try {
      const response = await axios.put(
        `${process.env.REACT_APP_API_URL}/client/${id}`,
        formData,
        {
          headers: { 'Content-Type': 'multipart/form-data' },
        }
      );
      alert('권리사 수정을 완료하였습니다.');
      navigate(`/Clients/${response.data.id}?page=${page}${searchParam}`);
    } catch (error) {
      const res = error.response;
      if (res?.status === 409 && res.data?.error === 'DUPLICATE_FIELD') {
        alert(res.data.message || '중복 항목이 있습니다.');
      } else {
        alert('수정 중 오류가 발생했습니다.');
      }
    }
  };

  return (
    <>
        <div className="flex mb-8 justify-center items-center">
          <div className="text-xl sm:text-2xl font-bold text-white tracking-tight">
            <span>권리사 수정</span>
          </div>
        </div>

        <div className="flex justify-center">
          <div className="space-y-6">
            {/* 권리사명 */}
            <div>
              <label className="block font-semibold mb-1">권리사명</label>
              <input
                type="text"
                value={name || ''}
                onChange={nameValueChange}
                className="w-full px-3 py-2 rounded-xl border border-white/[0.08] bg-[#1a2b42] text-slate-200"
              />
            </div>

            {/* 닉네임 */}
            <div>
              <label className="block font-semibold mb-1">닉네임</label>
              <input
                type="text"
                value={nickName || ''}
                onChange={nickNameValueChange}
                className="w-full px-3 py-2 rounded-xl border border-white/[0.08] bg-[#1a2b42] text-slate-200"
              />
            </div>

            {/* 아이디 */}
            <div>
              <label className="block font-semibold mb-1">아이디</label>
              <input
                type="text"
                value={clients.loginId || ''}
                className="w-full px-3 py-2 rounded-xl border border-white/[0.08] bg-white/[0.03] text-slate-300 focus:outline-none"
                readOnly
              />
            </div>

            {/* 패스워드 */}
            <div>
              <label className="block font-semibold mb-1">패스워드</label>
              <input
                type="password"
                value={password || ''}
                onChange={passwordValueChange}
                placeholder="****"
                autoComplete="new-password"
                className="w-full px-3 py-2 rounded-xl border border-white/[0.08] bg-[#1a2b42] text-slate-200 focus:outline-none focus:ring-2 focus:ring-sky-300 focus:border-transparent"
              />
              <small className="text-slate-400">
                비밀번호를 변경하려면 새 비밀번호를 입력하세요. 입력하지 않으면
                기존 비밀번호가 유지됩니다.
              </small>
            </div>

            {/* 전화번호 */}
            <div>
              <label className="block font-semibold mb-1">전화번호</label>
              <div className="flex gap-2">
                <input
                  type="text"
                  maxLength="3"
                  value={phone1 || ''}
                  onChange={phone1Change}
                  className="w-1/4 px-3 py-2 rounded-xl border border-white/[0.08] bg-[#1a2b42] text-slate-200"
                />
                <span className="self-center">-</span>
                <input
                  type="text"
                  maxLength="4"
                  value={phone2 || ''}
                  onChange={phone2Change}
                  className="w-1/4 px-3 py-2 rounded-xl border border-white/[0.08] bg-[#1a2b42] text-slate-200"
                />
                <span className="self-center">-</span>
                <input
                  type="text"
                  maxLength="4"
                  value={phone3 || ''}
                  onChange={phone3Change}
                  className="w-1/4 px-3 py-2 rounded-xl border border-white/[0.08] bg-[#1a2b42] text-slate-200"
                />
              </div>
            </div>

            {/* 이메일 */}
            <div>
              <label className="block font-semibold mb-1">이메일</label>
              <div className="flex items-center gap-2">
                <input
                  type="text"
                  value={emailId || ''}
                  onChange={emailIdChange}
                  className="w-1/3 px-3 py-2 rounded-xl border border-white/[0.08] bg-[#1a2b42] text-slate-200"
                />
                <span>@</span>
                <select
                  value={emailDomain}
                  onChange={emailDomainChange}
                  className="w-1/3 px-3 py-2 rounded-xl border border-white/[0.08] bg-[#1a2b42] text-slate-200">
                  <option value="gmail.com">gmail.com</option>
                  <option value="naver.com">naver.com</option>
                  <option value="hanmail.net">hanmail.net</option>
                  <option value="custom">직접입력</option>
                </select>
                {emailDomain === 'custom' && (
                  <input
                    type="text"
                    value={customDomain || ''}
                    onChange={customDomainChange}
                    placeholder="도메인 입력"
                    className="w-1/3 px-3 py-2 rounded-xl border border-white/[0.08] bg-[#1a2b42] text-slate-200"
                  />
                )}
              </div>
            </div>

            {/* 주소 */}
            <div className="relative">
              <label className="block font-semibold mb-1">주소</label>
              <div className="flex gap-2">
                <input
                  type="text"
                  placeholder="우편번호"
                  value={zonecode || ''}
                  className="w-1/4 px-3 py-2 rounded-xl border border-white/[0.08] bg-[#1a2b42] text-slate-200"
                  readOnly
                  onClick={handleAddressSearch}
                />
                <input
                  type="text"
                  placeholder="주소 검색"
                  value={address || ''}
                  className="flex-1 px-3 py-2 rounded-xl border border-white/[0.08] bg-[#1a2b42] text-slate-200"
                  readOnly
                  onClick={handleAddressSearch}
                />
              </div>
              <input
                type="text"
                placeholder="상세주소 입력"
                value={detailAddress || ''}
                onChange={addressValueChange}
                className="w-full px-3 py-2 rounded-xl border border-white/[0.08] bg-[#1a2b42] text-slate-200 mt-2"
              />

              {showPostcode && (
                <div
                  className="fixed inset-0 flex justify-center items-center z-50 bg-black bg-opacity-50"
                  onClick={() => setShowPostcode(false)}>
                  <div
                    className="relative"
                    onClick={(e) => e.stopPropagation()}>
                    <div
                      className="absolute -top-12 -right-0 shadow p-2 text-slate-300 text-md cursor-pointer z-10"
                      onClick={() => setShowPostcode(false)}
                      title="닫기">
                      닫기
                    </div>
                    <div className="bg-[#1a2b42] p-4 rounded-xl shadow-xl border border-white/10 w-[500px] max-h-[80vh] overflow-y-auto">
                      <DaumPostcode onComplete={handlePostcodeComplete} />
                    </div>
                  </div>
                </div>
              )}
            </div>

            {/* 유형 */}
            <div>
              <label className="block font-semibold mb-1">유형</label>
              <div className="flex gap-6">
                <label className="flex items-center gap-1">
                  <input
                    type="radio"
                    name="type"
                    value="개인"
                    onChange={typeValueChange}
                    checked={type === '개인'}
                  />
                  <span>개인</span>
                </label>
                <label className="flex items-center gap-1">
                  <input
                    type="radio"
                    name="type"
                    value="사업자"
                    onChange={typeValueChange}
                    checked={type === '사업자'}
                  />
                  <span>사업자</span>
                </label>
              </div>
            </div>

            {/* 주민등록번호 / 사업자등록번호 */}
            <div>
              {type === '개인' ? (
                <>
                  <label className="block font-semibold mb-1">
                    주민등록번호
                  </label>
                  <div className="flex items-center gap-2">
                    <input
                      type="text"
                      maxLength="6"
                      value={rrn1 || ''}
                      onChange={rrn1Change}
                      className="w-1/3 px-3 py-2 rounded-xl border border-white/[0.08] bg-[#1a2b42] text-slate-200"
                    />
                    <span>-</span>
                    <form className="w-1/3">
                      <input
                        type="password"
                        maxLength="7"
                        value={rrn2 || ''}
                        onChange={rrn2Change}
                        className="px-3 py-2 rounded-xl border border-white/[0.08] bg-[#1a2b42] text-slate-200"
                        autoComplete="new-password"
                      />
                    </form>
                  </div>
                </>
              ) : type === '사업자' ? (
                <>
                  <label className="block font-semibold mb-1">
                    사업자등록번호
                  </label>
                  <div className="flex items-center gap-2">
                    <input
                      type="text"
                      maxLength="3"
                      value={rrnA || ''}
                      onChange={rrnAChange}
                      className="w-1/4 px-3 py-2 rounded-xl border border-white/[0.08] bg-[#1a2b42] text-slate-200"
                    />
                    <span>-</span>
                    <input
                      type="text"
                      maxLength="2"
                      value={rrnB || ''}
                      onChange={rrnBChange}
                      className="w-1/4 px-3 py-2 rounded-xl border border-white/[0.08] bg-[#1a2b42] text-slate-200"
                    />
                    <span>-</span>
                    <input
                      type="text"
                      maxLength="5"
                      value={rrnC || ''}
                      onChange={rrnCChange}
                      className="w-1/4 px-3 py-2 rounded-xl border border-white/[0.08] bg-[#1a2b42] text-slate-200"
                    />
                  </div>
                </>
              ) : (
                <div></div>
              )}
            </div>
            {/* 은행 정보 */}
            <div>
              <label className="block font-semibold mb-1">은행 정보</label>
              <div className="flex gap-4">
                <input
                  type="text"
                  value={bank || ''}
                  onChange={(e) => setBank(e.target.value)}
                  placeholder="은행명"
                  className="w-1/3 px-3 py-2 rounded-xl border border-white/[0.08] bg-[#1a2b42] text-slate-200"
                />
                <input
                  type="text"
                  value={account || ''}
                  onChange={setAccountChange}
                  placeholder="계좌번호"
                  className="w-1/3 px-3 py-2 rounded-xl border border-white/[0.08] bg-[#1a2b42] text-slate-200"
                />
                <input
                  type="text"
                  value={holder || ''}
                  onChange={(e) => setHolder(e.target.value)}
                  placeholder="예금주"
                  className="w-1/3 px-3 py-2 rounded-xl border border-white/[0.08] bg-[#1a2b42] text-slate-200"
                />
              </div>
            </div>
          </div>
        </div>

        <div className="w-full flex justify-end items-center mt-5">
          <ButtonItem
            className="mr-2"
            text="목록"
            color="gray"
            onClick={() => navigate(`/Clients?page=${page}${searchParam}`)}
          />
          <ButtonItem
            className="mr-2"
            text="취소"
            color="red"
            onClick={() => navigate(`/Clients/${id}?page=${page}${searchParam}`)}
          />
          <ButtonItem text="등록" color="blue" onClick={add} />
        </div>
    </>
  );
}

export default ClientWritePage;
